import { render, staticRenderFns } from "./AbsenceRejectedDayLegend.vue?vue&type=template&id=ab978016&"
import script from "./AbsenceRejectedDayLegend.vue?vue&type=script&lang=js&"
export * from "./AbsenceRejectedDayLegend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports